export default "__VITE_ASSET__DO$rX7Yk__"